import { useEffect, useState } from "react";
import TransactionServices from "../TransactionServices";
import Svg_icon from "components/flags/svg_icon";
import DeleteDialogueBox from "components/Common/deleteDialogue";
import { CommonUtilities } from "commonUtils";

export default function Matching_Territory(param: any) {
    let [terrOurs, setterrOurs] = useState('')
    let [terrAlias, setterrAlias] = useState('')
    let [deleteData, setDeleteData] = useState<any>([]);
    let [deleteStatus, setDeleteStatus] = useState(false);
    let [searchterritory, setsearchterritory] = useState('')
    let [territoryAlias, setTerritoryAlias] = useState<any>([]);
    let [territoryAliasCount, setTerritoryAliasCount] = useState(0);
    let [territoryCodeList, setTerritoryCodeList] = useState<any>([]);
    let [UnmatchedTerritories, setUnmatchedTerritories] = useState<any>([]);
    let [updateSystemAliasTrue, setUpdateSystemAliasTrue] = useState(false);
    let [updateSystemAliasFalse, setUpdateSystemAliasFalse] = useState(false);

    const territoryAliases = () => {
        TransactionServices.getTerritoryCode({}).then((res: any) => {
            console.log(res)
            territoryAlias = res
            setTerritoryAlias(res)
            territoryAliasCount = res?.length ?? 0
            setTerritoryAliasCount(territoryAliasCount)
        })
    }

    const createAlias = () => {

        if (terrAlias?.length == 0 || terrOurs?.length == 0) {
            CommonUtilities.showToastDawer("Please select an unmatched territory followed by the system territory", 'fail');
        } else {
            TransactionServices.saveTerritoryAliases({ terrAlias: terrAlias, terrOurs: terrOurs }).then(() => {
                CommonUtilities.showToastDawer(terrAlias + "has been matched successfully with System territories", 'Success');
            })
        }

    }

    const unmatchedEntriesExport = () => { TransactionServices.getUnmatchedTerritoriesExport({}) }

    useEffect(() => {

        TransactionServices.territoryCode({}).then((respond: any) => setTerritoryCodeList(respond))

        TransactionServices.getUnmatchedTerritories({}).then((respond: any) => setUnmatchedTerritories(respond))

    }, []);

    const deleteTerritoryAliases = (e: any) => {
        deleteData = e
        setDeleteData(deleteData);

        deleteStatus = true;
        setDeleteStatus(deleteStatus)
    }

    const Confirmation = (e: any) => {
        console.log(e)
        if (e === 1) {
            TransactionServices.deleteTerritoryAliases(deleteData).then(() => {
                territoryAliases()
                CommonUtilities.showToastDawer("Matched Territory  has been deleted successfully", 'fail');
            })
        }

        deleteStatus = false;
        setDeleteStatus(deleteStatus)
    }

    const exportTerritories = () => { TransactionServices.getTerritoryAliasesExport({}) }

    return (
        <>
            <div className="ws-12 allowHscroll allowVscroll">

                <div className="box mbl borderRounded">

                    <h2 className="mt mll"> Matching Territories</h2>

                    <div className="box-content form-box">
                        {updateSystemAliasTrue && <div className="alert alert-info">Operation queued for processing</div>}
                        {updateSystemAliasFalse && <div className="alert alert-info">Re-run this operation after a few mins as similar job already in progress</div>}
                        {false && <div className="alert alert-info">Please select an unmatched territory followed by the system territory</div>}

                        <div className="ws-12">

                            <div className="ws-4">
                                <div className="label-entries">
                                    <input type="text" className="form-control ws-11" placeholder="Filter Unmatched entries" data-ng-model="territoryCodeUnmatchFilter" id="unmatchedEntries" />

                                    <div className="ws-11 height200 mt box pm allowHscroll allowVscroll">
                                        <span className="mb text-bold"> Choose unmatched territory</span>

                                        {
                                            UnmatchedTerritories?.map((terRes: any) => {
                                                return (
                                                    <span className={terrAlias == terRes?.repTerritoryCode ? "bg-level3 ws-12 text-bold p1" : "ws-12 text-bold"}
                                                        onClick={() => setterrAlias(terRes?.repTerritoryCode)}>
                                                        {terRes?.repTerritoryCode}
                                                    </span>
                                                )
                                            })
                                        }
                                    </div>
                                </div>

                            </div>

                            <div className="ws-4">
                                <div className="label-entries">
                                    <input type="text" className="form-control ws-11" placeholder="Filter System territories" data-ng-model="territoryCodeFilter" id="search" />

                                    <div className="ws-11 height200 mt box pm allowHscroll allowVscroll">
                                        <span className="mb text-bold">Choose unmatched territory</span>
                                        {
                                            territoryCodeList?.map((terRes: any) => {
                                                return (
                                                    <div className={terrOurs == terRes?.territoryCode ? "bg-level3 ws-12 ps mt p1" : "ws-12 ps mt"}
                                                        onClick={() => setterrOurs(terRes?.territoryCode)}>
                                                        <Svg_icon IName={terRes?.territoryCode} />
                                                        <span className="ws-2">{terRes?.territoryCode}</span>
                                                        <span className="ws-8 text-bold">{terRes?.territoryName}</span>
                                                    </div>

                                                )
                                            })
                                        }
                                    </div>

                                </div>

                            </div>

                            <div className="ws-4">
                                <div className="ws-11 pull-right">
                                    <label className="control-label ws-12 text-center text-bold" >Unmatched entries</label>
                                    <div className="label-entries">
                                        <input type="text" className="form-control ws-12" placeholder="Unmatched entries" value={terrAlias} id="unmatchedentries" readOnly />
                                    </div>

                                </div>

                                <div className="ws-11 pull-right mtl">
                                    <label className="control-label ws-12 text-center text-bold " >Match to</label>
                                    <div className="label-entries">
                                        <input type="text" className="form-control ws-12" placeholder="Matched entries" value={terrOurs} id="matchTo" readOnly />
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>

                    <div className="ws-12 pm">
                        <button className="icon-btn edit pull-right " onClick={createAlias}><i className="icon-list icon-white"></i> Create Alias</button>
                        <button className="icon-btn primary pull-right" onClick={unmatchedEntriesExport} title="Unmatched territories"> <i className="icon-download1"></i> </button>
                    </div>

                </div>

                <div className="box borderRounded">
                    <h2 className="mt mll"> Existing Territories Alias - {territoryAliasCount} record(s) found</h2>

                    {false && <div className="alert alert-info">has been matched successfully with System territories</div>}
                    {false && <div className="alert alert-info">Matched Territory  has been deleted successfully</div>}

                    <div className="box-content">

                        {territoryAliasCount == 0 && <button className="icon-btn primary btn-sm mb w-12" onClick={territoryAliases}><span className="ws-11 "> Load all aliases</span> </button>}

                        {territoryAliasCount > 0 && <div className="ws-12">
                            <div className="form-format ws-6">
                                <label className="control-label ">Filter</label>

                                <div className="label-entries">
                                    <input type="text" className="form-control input-sm " placeholder="Search" value={searchterritory} onChange={(e: any) => setsearchterritory(e.target.value)} id="territory" />
                                </div>
                            </div>
                        </div>}

                        {searchterritory?.length > 0 && territoryAliasCount == 0 && <div className="alert alert-int">No record matches your search criteria</div>}
                        {territoryAliasCount == 0 && <div className="alert alert-int">No Territories Alias added yet</div>}

                        {territoryAliasCount > 0 && <table className="newTable">
                            <thead>
                                <tr>
                                    <th >Unmatched Territory</th>
                                    <th >System Territory</th>
                                    <th >Operation</th>
                                </tr>
                            </thead>
                            <tbody>
                                {territoryAlias?.
                                    filter((alias: any) => {
                                        if (searchterritory?.length == 0) {
                                            return true;
                                        }
                                        return alias.terrAlias?.includes(searchterritory) || alias.terrOurs?.includes(searchterritory)
                                    })?.
                                    map((values: any) => {
                                        return (
                                            <tr>
                                                <td> <Svg_icon IName={values?.terrAlias} />{values.terrAlias}</td>
                                                <td> <Svg_icon IName={values?.terrOurs} />{values.terrOurs}</td>
                                                <td>
                                                    <a title="Delete" className=" icon-btn delete" onClick={() => deleteTerritoryAliases(values)}>
                                                        <i className="icon-trashcan"></i>
                                                    </a>
                                                </td>
                                            </tr>
                                        )
                                    })}
                            </tbody>
                        </table>}

                        {territoryAliasCount > 0 && <div className="clearfix mt">

                            <button className="icon-btn primary mt  " onClick={exportTerritories}>Export</button>
                        </div>}

                    </div>

                </div>

                {
                    (() => {

                        if (deleteStatus) {
                            return <DeleteDialogueBox param={true} message={"delete this territory alias " + deleteData?.terrAlias} onChange={Confirmation} />
                        }
                    })()
                }

            </div>
        </>
    )
}